export const mail = {
    '站内信': 'Pesan Internal',
    '返回': 'Kembali',
    '有未读信息': 'Ada {amount} pesan belum dibaca',
    '全部标记为已读': 'Tandai Semua sebagai Sudah Dibaca',
    '隐藏已读消息': 'Sembunyikan Pesan yang Sudah Dibaca',
    '展开': 'Bentangkan',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/ba.js